export default class Social {
    
    disable_facebook_login = false
    show_products_on_start = false

    constructor(disable_facebook_login = false, show_products_on_start = false) {
        this.disable_facebook_login = disable_facebook_login
        this.show_products_on_start = show_products_on_start
    }
}